var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeatures5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#243A76;}\r\n\t.st1{fill:#152456;}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:#FBB034;}\r\n\t.st4{clip-path:url(#SVGID_2_);}\r\n\t.st5{fill:none;stroke:#FFFFFF;stroke-width:1.3985;stroke-miterlimit:10;}\r\n\t.st6{fill:none;stroke:#FBB034;stroke-width:1.3985;stroke-miterlimit:10;}\r\n\t.st7{fill:none;stroke:#FFFFFF;stroke-width:1.5539;stroke-miterlimit:10;}\r\n\t.st8{fill:none;}\r\n\t.st9{fill:none;stroke:#FBB034;stroke-width:2.8346;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 28.4,
    y: 71.4,
    className: "st3",
    width: 19.5,
    height: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M51.9,60.9l-3.3-6.6c1.9,0,2.7-1.1,2.8-1.1l-1.1-0.9c0,0-0.7,0.8-2.4,0.5l-0.1-0.2l-0.1,0.2 c-0.3-0.1-0.6-0.1-1-0.2c-1.4-0.5-2.2-1.1-3-1.6c-0.8-0.6-1.6-1.2-3-1.4c-0.9-0.1-1.5,0-1.9,0.1V48h-1.4v1.8 c-0.5-0.1-1-0.2-1.8-0.1c-1.4,0.1-2.2,0.7-3,1.4c-0.7,0.5-1.6,1.2-3,1.6c-0.4,0.1-0.7,0.2-1,0.2l-0.1-0.2l-0.1,0.2 c-1.7,0.2-2.3-0.5-2.4-0.5l-1.1,0.9c0,0.1,0.9,1.1,2.8,1.1l-3.3,6.6h-1.8l0,0.7c0,0.1,0.1,5.2,6,5.2c5.8,0,6-5.1,6-5.2l0-0.7h-1.8 l-3.4-6.8c0.2-0.1,0.5-0.1,0.8-0.2c1.6-0.5,2.6-1.3,3.4-1.8c0.8-0.6,1.3-1,2.3-1.1c1.2-0.1,1.6,0.1,1.7,0.2v16.4h-4.7v1.4h11v-1.4 h-4.9V51.2l0.1,0c0,0.1,0,0.1,0,0.1c0,0,0.3-0.4,1.7-0.2c1,0.1,1.5,0.5,2.3,1.1c0.8,0.6,1.7,1.3,3.4,1.8c0.3,0.1,0.5,0.2,0.8,0.2 l-3.4,6.8h-1.8l0,0.7c0,0.1,0.1,5.2,6,5.2s6-5.1,6-5.2l0-0.7H51.9z M28.4,65.4c-3.3,0-4.2-2-4.5-3.1h9 C32.6,63.4,31.7,65.4,28.4,65.4z M25.8,60.9l2.6-5.1l2.6,5.1H25.8z M37.3,51.2L37.3,51.2L37.3,51.2C37.3,51.2,37.3,51.2,37.3,51.2 z M47.7,55.8l2.6,5.1h-5.2L47.7,55.8z M47.7,65.4c-3.3,0-4.2-2-4.5-3.1h9C51.9,63.4,51,65.4,47.7,65.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M65.7,61.8V30.3c0-3.9-3.2-7.1-7.1-7.1H25.6c-3.4,0-6.1,2.7-6.1,6.1v5l10.8-0.2V48h1.4V29.3 c0-1.9-0.9-3.6-2.2-4.7h29.2c3.1,0,5.7,2.5,5.7,5.7v36.4c0,1.9,0.9,3.6,2.2,4.7H50.8v1.4h19.6c3.4,0,6.1-2.7,6.1-6.1v-5L65.7,61.8 z M30.3,29.3v3.4l-9.4,0.2v-3.6c0-2.6,2.1-4.7,4.7-4.7S30.3,26.7,30.3,29.3z M75.1,66.7c0,2.6-2.1,4.7-4.7,4.7s-4.7-2.1-4.7-4.7 v-3.4l9.4-0.2V66.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.3,
    y: 33.3,
    className: "st2",
    width: 22.2,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.3,
    y: 37.8,
    className: "st2",
    width: 22.2,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.3,
    y: 42.3,
    className: "st2",
    width: 22.2,
    height: 1.4
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatures5);
export default __webpack_public_path__ + "static/media/features5.a24a51d7bae002b96b82cb17ce01d6cf.svg";
export { ForwardRef as ReactComponent };